import styled from '@emotion/styled';
import { breakpoints, radius, spacing } from '@naf/theme';
import { nafColor } from '@nafcore/theme';

export const BenefitHeaderContainer = styled.div``;

export const ImageWrapper = styled.div`
  position: relative;
  margin: ${spacing.space40} auto 0;
  padding: 0;
  width: 100%;

  @media (max-width: ${breakpoints.m}) {
    margin-top: ${spacing.space24};
  }
`;

export const ImageFigure = styled.figure`
  margin: 0;
  position: relative;
  overflow: hidden;
  border-radius: ${radius.l} ${radius.l} 0 0;
  height: clamp(220px, 56vw, 512px);

  img {
    width: 100%;
    max-height: 512px;
    object-fit: cover;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 40%;
    background: linear-gradient(
      to bottom,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.8) 70%,
      rgba(255, 255, 255, 1) 90%
    );
  }
`;

export const PartnerlogoWrapper = styled.div`
  position: absolute;
  top: -${spacing.space12};
  left: ${spacing.space16};
  background-color: ${nafColor.signature.white};
  border-radius: ${radius.s};
  padding: ${spacing.space8};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  box-shadow: 0 ${spacing.space4} ${spacing.space8} ${nafColor.signature.black}33;

  img {
    height: ${spacing.space32};
  }

  @media (min-width: ${breakpoints.m}) {
    left: ${spacing.space64};
  }
`;

export const ImageLoadingOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 1;
  background: ${nafColor.neutral.neutral1};
`;

export const ImageInner = styled.div`
  position: absolute;
  inset: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;
